import { DateTime as DateTime$1 } from "../../../components/DateTime/index.js";
import { useLocation } from "../../Locations/hooks/useLocation.js";
import { IdLabel } from "../../../components/IdLabel/index.js";
import { PRIORITY_VALUE_NAME_MAP, PRIORITY_VALUE_VARIANT_MAP } from "../../../components/Priority/constants.js";
import { Tags } from "../../Tags/shared/Tags.js";
import { UserNameWithAvatar } from "../../Users/shared/UserNameWithAvatar.js";
import { EventTypeTitle } from "./EventTypeTitle.js";
/* empty css                  */
import { ColorCircle, Skeleton } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { formatAddress } from "@therms/web-js";
import classnames from "classnames";
//#region src/modules/Events/shared/EventListCard.tsx
function EventListCard({ event, onClick, showLocationAddress = true }) {
	const { data } = useLocation(showLocationAddress ? { locationId: event.locationId } : void 0, { cacheStrategy: "cache-only" });
	const location = data?.location;
	return /* @__PURE__ */ jsxs("div", {
		className: classnames("event-card-container space-xxs bg-surface flex flex-col rounded-sm", { "hover:bg-surface-strong focus:bg-surface-strong active:bg-surface-subtle group cursor-pointer transition-colors": onClick }),
		onClick: () => onClick?.(event),
		children: [
			/* @__PURE__ */ jsxs("div", {
				className: classnames(`gap-x-xs px-sm py-xs flex flex-wrap items-center justify-between rounded-t-sm text-sm font-bold bg-${PRIORITY_VALUE_VARIANT_MAP[event.priority]}-faded`, { "transition-colors": onClick }),
				children: [/* @__PURE__ */ jsxs("div", {
					className: "gap-x-xxs flex flex-wrap",
					children: [/* @__PURE__ */ jsx(IdLabel, {
						className: "traking-wide text-color-subtle text-sm font-bold",
						idLabel: event.idLabel
					}), !!event.priority && /* @__PURE__ */ jsxs("div", {
						className: `text-color-strong`,
						children: [PRIORITY_VALUE_NAME_MAP[event.priority], " Priority"]
					})]
				}), /* @__PURE__ */ jsxs("div", {
					className: "gap-x-xxs flex flex-wrap justify-end",
					children: [/* @__PURE__ */ jsx("div", {
						className: "text-color-subtle font-light",
						children: /* @__PURE__ */ jsx(DateTime$1, {
							relative: true,
							timestamp: event.date,
							toggleRelativeOnClick: false
						})
					}), /* @__PURE__ */ jsx("div", {
						className: "text-color-strong",
						children: /* @__PURE__ */ jsx(DateTime$1, {
							mode: "time",
							timestamp: event.date,
							toggleRelativeOnClick: false
						})
					})]
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "px-sm py-xs",
				children: [
					/* @__PURE__ */ jsxs("div", {
						className: "gap-x-xs text-color-strong flex flex-wrap truncate",
						children: [/* @__PURE__ */ jsx("div", {
							className: "truncate font-bold",
							children: /* @__PURE__ */ jsx(EventTypeTitle, { eventType: event.eventType })
						}), /* @__PURE__ */ jsx("div", {
							className: "flex-1 truncate font-light",
							children: event.subTitle
						})]
					}),
					showLocationAddress && /* @__PURE__ */ jsx("div", { children: location ? formatAddress(location?.address) : /* @__PURE__ */ jsx(Skeleton.Text, {
						chars: 75,
						lines: 1
					}) }),
					!!event.description && /* @__PURE__ */ jsx("div", {
						className: "mt-xxs line-clamp-3 text-sm",
						children: event.description
					})
				]
			}),
			/* @__PURE__ */ jsx("div", {
				className: classnames(`divide-border bg-surface-subtle divide-y truncate`, { "group-hover:bg-surface group-focus:bg-surface group-active:bg-background transition-colors": onClick }),
				children: event.assignedUsers.length ? event.assignedUsers.map((user) => /* @__PURE__ */ jsxs("div", {
					className: "gap-xs px-sm py-xs flex flex-wrap items-center",
					children: [/* @__PURE__ */ jsx(UserNameWithAvatar, { userId: user.userId }), /* @__PURE__ */ jsxs("div", {
						className: "flex-1 text-right",
						children: [
							user.status?.color && /* @__PURE__ */ jsx(ColorCircle, {
								color: user.status?.color,
								marginRight: true
							}),
							" ",
							user.status?.title
						]
					})]
				}, user.userId)) : /* @__PURE__ */ jsx("div", {
					className: "p-xs text-color-subtle text-center italic",
					children: "Unassigned"
				})
			}),
			!!event.activityTypeTags?.length && /* @__PURE__ */ jsx("div", {
				className: "p-xs",
				children: /* @__PURE__ */ jsx(Tags, {
					max: 3,
					tags: event.activityTypeTags
				})
			})
		]
	});
}
//#endregion
export { EventListCard };

//# sourceMappingURL=EventListCard.js.map